import React, { Component, useState, useEffect } from "react";
import { styled, useTheme } from '@mui/material/styles';
import { useSelector, useDispatch } from 'react-redux';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import Select from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AutoFixNormalIcon from '@mui/icons-material/AutoFixNormal';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ReplayIcon from '@mui/icons-material/Replay';
import OutputIcon from '@mui/icons-material/Output';
import LockIcon from '@mui/icons-material/Lock';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import { UserInfo, netGet, netPost, netFetch, keycloak } from "../network";
import { Edit } from "@mui/icons-material";
import { DownloadProfiles } from "./management-download-profiles";
import { RevisionRecordConfig } from "./management-revision-record";
import {
    CreateDocumentGeneralPanel, CreateDocumentSchemaPanel, CreateProcessingConfigurationPanel, CreateDocumentEffectivityPanel,
    EditDocumentGeneralPanel, EditDocumentSchemaPanel, EditDocumentEffectivityPanel, EditProcessingConfigurationPanel,
} from "./management-document-setup";
import { WorkflowInstance } from "../workflow/workflow";
import { MessageHooks } from "../../App";
import { WizardDialog } from "../wizard/wizard";
import { setConfigDocument, setConfigGeneral, setConfigSchema, setConfigEffectivity, setConfigOutput } from "../../features/management/managementSlice";

// import { setOpenNextStep } from "../../features/menu/menuSlice";

var nextDocumentSelectedId = -1;

function EditRuleDialog(props) {
    const {
        rules,
        ruleIndex,
        open,
        onSave,
        onCancel,
        title,
        create,
        ...other
    } = props;

    const [rule, setRule] = React.useState({ 'xpath': '', 'regex': '', 'action': 'TOGETHER', 'group': 0 });
    const [index, setIndex] = React.useState(0);
    const [xpathValue, setXpathValue] = React.useState('');
    const [xpathChanged, setXpathChanged] = React.useState(false);
    const [changed, setChanged] = React.useState(false);

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 320,
            },
        },
    };

    React.useEffect(() => {
        if (rules && ruleIndex >= 0) {
            const ir = Array.isArray(rules) && ruleIndex < rules.length && rules.length > 0 ? rules[ruleIndex] : undefined;
            if (ir) {
                const r = {
                    'xpath': ir.xpath,
                    'regex': ir.regex,
                    'action': ir.action ? ir.action : 'TOGETHER',
                    'group': ir.group ? Number(ir.group) : 0,
                };
                if (r.group === NaN) {
                    r.group = 0;
                }
                setRule(r);
            }
        }
        if (create) {
            const i = rules ? rules.length : 0;
            setIndex(i);
            setRule({ 'xpath': '', 'regex': '', 'action': 'TOGETHER', 'group': 0 });
        } else {
            setIndex(ruleIndex);
        }
    }, [rules, ruleIndex, open]);

    const onXpathChanged = (event) => {
        setChanged(true);
        const r = { ...rule };
        r.xpath = event.target.value;
        setRule(r);
    }

    const onRegexChanged = (event) => {
        setChanged(true);
        const r = { ...rule };
        r.regex = event.target.value;
        setRule(r);
    };

    const onGroupChanged = (event) => {
        setChanged(true);
        const r = { ...rule };
        r.group = Number(event.target.value);
        if (r.group === NaN) {
            r.group = 0;
        }
        setRule(r);
    };

    const handleActionChange = (event) => {
        setChanged(true);
        const r = { ...rule };
        r.action = event.target.value;
        setRule(r);
    };

    const onOKClick = () => {
        if (typeof onSave === 'function') {
            const r = { ...rule };
            r.group = Number(r.group);
            if (r.group === NaN) {
                r.group = 0;
            }
            onSave(r);
        }
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const handleExpressionChange = (event) => {
        console.log('expression: ' + event.target.value);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    minWidth: '500px',
                    width: '900px',
                    maxWidth: '900px',
                    maxHeight: '900px',
                    height: 600
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{ paddingTop: '3em', whiteSpace: 'nowrap' }}>
                    <Typography sx={{ display: 'inline-block', width: '5em', fontWeight: 'bold' }}>No: </Typography>
                    <Typography sx={{ display: 'inline-block' }}>{index}</Typography>
                </Box>
                <Box sx={{ paddingTop: '3ex', display: 'flex', alignItems: 'top' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '5em' }}>XPath:</Typography>
                    <TextField value={rule.xpath} onChange={onXpathChanged} size="small" fullWidth
                        multiline rows={2} />
                </Box>
                <Box sx={{ paddingTop: '3ex', display: 'flex', alignItems: 'top' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '5em' }}>Regex:</Typography>
                    <TextField value={rule.regex} onChange={onRegexChanged} size="small" fullWidth
                        multiline rows={2} />
                </Box>
                <Box sx={{ paddingTop: '3ex', display: 'flex', alignItems: 'center' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '5em' }}>Group:</Typography>
                    <TextField value={rule.group} onChange={onGroupChanged} size="small" fullWidth
                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} />
                </Box>
                <Box sx={{ display: 'flex', paddingTop: '2em', alignItems: 'center' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '5em' }}>Action:</Typography>

                    <FormControl sx={{ m: 1, minWidth: 120, width: 'calc(100% - 3em)' }} size="small">
                        <Select
                            value={rule.action}
                            onChange={handleActionChange}
                            sx={{ minWidth: '20em', maxWidth: '100%' }}
                            MenuProps={MenuProps}
                        >
                            {['TOGETHER', 'WITH-PREVIOUS', 'WITH-NEXT'].map((cmd) => (
                                <MenuItem
                                    key={cmd}
                                    value={cmd}
                                >
                                    {cmd}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions sx={{ paddingRight: 'calc(8px + 2ex)', paddingBlock: 'calc(8px + 1ex)' }}>
                <Button variant="outlined" onClick={onOKClick} sx={{ minWidth: '7em' }}>OK</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em' }}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}

function a11yProps(index) {
    return {
        id: `docs-config-tab-${index}`,
        'aria-controls': `docs-config-tabpanel-${index}`,
    };
}

function DocumentConfigEdit(props) {
    const {
        doc,
        onChange,
        documentIndex,
        documentList,
        saveEnabled,
        readOnly,
        ...other
    } = props;

    const [rules, setRules] = React.useState([]);
    const [serial, setSerial] = React.useState(0);
    const [configKey, setConfigKey] = React.useState('');
    const [selectedIndex, setSelectedIndex] = React.useState(-1);
    const [saveDocEnabled, setSaveDocEnabled] = React.useState(false);
    const [addRuleEnabled, setAddRuleEnabled] = React.useState(true);
    const [editRuleEnabled, setEditRuleEnabled] = React.useState(false);
    const [deleteRuleEnabled, setDeleteRuleEnabled] = React.useState(false);
    const [editRuleDialogOpen, setEditRuleDialogOpen] = React.useState(false);
    const [editRuleCreateMode, setEditRuleCreateMode] = React.useState(true);
    const [dialogTitle, setDialogTitle] = useState('Add Rule');
    const [tabIndex, setTabIndex] = useState(0);

    const theme = useTheme();

    React.useEffect(() => {
        const key = `${doc?.configBaseKey}.workflow.keeps.word.rules`;
        setConfigKey(key);
        setSelectedIndex(-1);
        setDeleteRuleEnabled(false);
        setEditRuleEnabled(false);
        setEditRuleDialogOpen(false);
        setAddRuleEnabled(!readOnly);
        const url = `/api/config/vlist?key=${key}`;
        const url2 = `/api/config/vget?key=${key}.serial`;
        // console.log('cmd: ' + url);
        netGet(url)
            .then(response => response.json())
            .then(irules => {
                if (Array.isArray(irules)) {
                    // console.log('Got ' + irules.length + ' rules.\n' + JSON.stringify(irules));
                    /*
                    netGet(url2)
                        .then(response => response.json())
                        .then(res => {
                            console.log('Got raw serial ' + JSON.stringify(res));
                            const rserial = res && res.v ? res.v : 0;
                            let iserial = Number(rserial);
                            if ( iserial === NaN ) {
                                iserial = 0;
                            }
                            console.log('Got serial ' + iserial);
                            if ( iserial >= serial ) {
                                setRules(irules);
                            }
                        }).catch ( error => {
                            console.log('Error fetching semantic rules serial: ' + error);
                        });
                    */
                    setRules(irules);
                }
            }).catch(error => {
                console.log('Error fetching semantic rules: ' + error);
            });

    }, [doc, documentIndex, documentList, readOnly]);

    const handleTabChange = (event, index) => {
        // console.log('Tab Index: ' + index);
        setTabIndex(index);
    };


    const handleChange = (therules) => {
        if (typeof onChange === 'function') {
            let rserial = serial + 1;
            setSerial(rserial);

            netPost(`/api/config/set?key=${configKey}`, therules)
                .then(resp => {
                    if (!resp.ok) {
                        console.log('Could not save rules: status = ' + resp.status);
                    } else {
                        // delete def.saveSteps;
                        // setSaveDocumentEnabled(false);
                        // handleItemClick(selectedIndex);
                        // unmarkModified();
                    }
                });

            onChange(therules, doc, documentIndex);
        }
    };

    const handleProfilesSave = (dprofiles) => {
        if (typeof onChange === 'function') {
            onChange(undefined, doc, documentIndex, { profiles: dprofiles });
        }
    };

    const handleGeneralSave = (data) => {
        if (typeof onChange === 'function') {
            onChange(undefined, doc, documentIndex, { general: data });
        }
    };

    const handleSchemaSave = (data) => {
        onChange(undefined, doc, documentIndex, {schema: data});
    }

    const handleEffectivitySave = (data) => {
        onChange(undefined, doc, documentIndex, {effectivity: data});
    }

    const handleOutputSave = (data) => {
        // console.log('Saving: ' + JSON.stringify(data));
        onChange(undefined, doc, documentIndex, {output: data});
    }

    const handleRevisionRecordSave = (rr) => {
        if (typeof onChange === 'function') {
            onChange(undefined, doc, documentIndex, rr);
        }
    };

    const handleRowClick = (index) => {
        setSelectedIndex(index);
        setDeleteRuleEnabled(index >= 0 && !readOnly);
        setEditRuleEnabled(index >= 0 && !readOnly);
    };

    const handleCreateRuleAction = () => {
        if (!readOnly) {
            setDialogTitle('Add Rule');
            setEditRuleCreateMode(true);
            setEditRuleDialogOpen(true);
        }
    };

    const handleEditRuleAction = () => {
        if (!readOnly) {
            setDialogTitle('Edit Rule');
            setEditRuleCreateMode(false);
            setEditRuleDialogOpen(true);
        }
    };

    const handleDeleteRuleAction = () => {
        if (!readOnly) {
            const i = selectedIndex;
            const rs = [...rules];
            rs.splice(i, 1);
            setSelectedIndex(-1);
            setRules(rs);
            // console.log('Deleted index ' + i);
            handleChange(rs);
        }
    };

    const onEditRuleSave = (rule) => {
        if (!readOnly) {
            setEditRuleDialogOpen(false);
            const rs = [...rules];
            // console.log('New rule: ' + JSON.stringify(rule));
            if (editRuleCreateMode) {
                rs.push({ ...rule });
            } else {
                rs[selectedIndex] = { ...rule };
            }
            setRules(rs);
            handleChange(rs);
        }
    };

    const onEditRuleCancel = () => {
        setEditRuleDialogOpen(false);
    };

    return (
        <Box sx={{ position: 'relative', width: '100%', height: '100%', padding: '1ex', paddingTop: '2ex', display: 'grid', gridTemplateRows: 'min-content minmax(10px,1fr) min-content' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabIndex} onChange={handleTabChange} aria-label="config tabs">
                    <Tab label="General Information" {...a11yProps(0)} />
                    <Tab label="Schema" {...a11yProps(1)} />
                    <Tab label="Effectivity" {...a11yProps(2)} />
                    <Tab label="Outputs" {...a11yProps(3)} />
                    <Tab label="Revision Record" {...a11yProps(4)} />
                    <Tab label="Semantic Pre-proccessor" {...a11yProps(5)} />
                    {/* <Tab label="Download Profiles" {...a11yProps(10)} /> */}
                </Tabs>
            </Box>
            {tabIndex === 0 &&
                <EditDocumentGeneralPanel document={doc} documentList={documentList} readOnly={readOnly} onChange={handleGeneralSave} />
            }
            {tabIndex === 1 &&
                <EditDocumentSchemaPanel document={doc} open={tabIndex === 1} onChange={handleSchemaSave} readOnly={readOnly} />
            }
            {tabIndex === 2 &&
                <EditDocumentEffectivityPanel document={doc} open={tabIndex === 2} onChange={handleEffectivitySave}  readOnly={readOnly} />
            }
            {tabIndex === 3 &&
                <EditProcessingConfigurationPanel document={doc} open={tabIndex === 3} onChange={handleOutputSave} readOnly={readOnly} />
            }
            {tabIndex === 4 &&
                <RevisionRecordConfig doc={doc} onChange={handleRevisionRecordSave} readOnly={readOnly} open={tabIndex === 4} />
            }
            {tabIndex === 5 &&
                <React.Fragment>
                    <Box sx={{ paddingTop: '2em' }}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="semantic table">
                                <TableHead>
                                    <TableRow sx={{ fontWeight: 'bold', borderBottom: 2 }}>
                                        <TableCell sx={{ fontWeight: 'bold' }} align="center">No.</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>XPath</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Regex</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} align="center">Group</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rules.map((rule, index) => (
                                        <TableRow selected={index === selectedIndex}
                                            onClick={() => handleRowClick(index)}
                                            key={`r-${doc.id}-${index}`}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }} align="center">
                                                {index}
                                            </TableCell>
                                            <TableCell>{rule.xpath}</TableCell>
                                            <TableCell>{rule.regex}</TableCell>
                                            <TableCell align="center">{rule.group ? Number(rule.group) : 0}</TableCell>
                                            <TableCell>{rule.action ? rule.action : 'TOGETHER'}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box sx={{ padding: '1ex', whiteSpace: 'nowrap', overflowX: 'hidden' }} color={theme.palette.primary.main}>
                        <Tooltip title="Create Rule">
                            <span>
                                <IconButton color="inherit" sx={{ marginLeft: '1em', paddingLeft: '6px', paddingRight: '6px' }} disabled={!addRuleEnabled} onClick={handleCreateRuleAction} >
                                    <AddIcon color="inherit" />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="Edit Rule">
                            <span>
                                <IconButton color="inherit" disabled={!editRuleEnabled} onClick={handleEditRuleAction}>
                                    <AutoFixNormalIcon color="inherit" />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="Delete Rule">
                            <span>
                                <IconButton color="inherit" disabled={!deleteRuleEnabled} onClick={handleDeleteRuleAction} sx={{ paddingLeft: '6px', paddingRight: '6px' }}>
                                    <DeleteIcon color="inherit" />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <EditRuleDialog rules={rules} ruleIndex={selectedIndex} onCancel={onEditRuleCancel} onSave={onEditRuleSave} open={editRuleDialogOpen}
                            create={editRuleCreateMode} title={dialogTitle} />
                    </Box>
                </React.Fragment>
            }
            {/* tabIndex === 1 &&
                <DownloadProfiles doc={doc} onChange={handleProfilesSave} readOnly={readOnly} />
            */}

        </Box>
    );

}

function DocumentDeleteDialog(props) {
    const {
        title = 'Delete Document',
        open,
        onSave,
        onCancel,
        document,
        ...other
    } = props;

    const [okEnabled, setOkEnabled] = useState(false);
    const [forceDeleteOpen, setForceDeleteOpen] = useState(false);


    React.useEffect(() => {
        if (open && document) {
            console.log('DOC: ' + JSON.stringify(document));
            setOkEnabled(true);
        } else {
            setOkEnabled(false);
        }
        setForceDeleteOpen(false);
    }, [open, document]);



    const onOKClick = () => {
        if (typeof onSave === 'function') {
            onSave(document);
        }
    }

    const forceDeleteSave = () => {
        if (typeof onSave === 'function') {
            onSave(document);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const getIdentifier = () => {
        return document?.id;
    };

    const getDescription = () => {
        if (document?.description) {
            return document.description;
        }
        if (document?.workflowInstance?.description) {
            return document.workflowInstance.description;
        }
        return ' ';
    };

    const getName = () => {
        if (document?.title) {
            return document.title;
        }
        return ' ';
    };

    return (
        <Dialog
            maxWidth={'1000px'}
            open={open}
            disableRestoreFocus
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 600,
                        maxHeight: 700
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent>

                <Box sx={{ paddingTop: '2ex' }}>
                    <TextField label="Identifier" size="small" fullWidth value={getIdentifier()}
                        slotProps={{
                            input: {
                                readOnly: true,
                            }
                        }} />
                </Box>

                <Box sx={{ paddingTop: '2ex' }}>
                    <TextField label="Document Name" size="small" fullWidth value={getName()}
                        slotProps={{
                            input: {
                                readOnly: true,
                            }
                        }} />
                </Box>

                <Box sx={{ paddingTop: '3ex' }}>
                    <TextField label="Description" size="small" fullWidth value={getDescription()}
                        multiline rows={3} slotProps={{
                            input: {
                                readOnly: true,
                            }
                        }} />
                </Box>


                <Box sx={{ paddingTop: '5ex' }}>
                    <Typography sx={{ display: 'inline', fontWeight: 'bold' }}>Delete document?</Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ padding: 3 }}>
                <Button variant="outlined" onClick={onOKClick} sx={{ minWidth: '7em' }} color="error" disabled={!okEnabled} autoFocus >Delete</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em' }}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

const CREATE_PANELS = [
    'GEN',
    'SCH',
    'EFF',
    'OUT',
];

function DocumentCreateDialog(props) {
    const {
        title = 'Create Document',
        open,
        onCancel,
        onSave,
        documentList,
        ...other
    } = props;
    const [panel, setPanel] = useState(null);
    const [panelIndex, setPanelIndex] = useState(0);
    const [panelId, setPanelId] = useState('GEN');
    const [panelTitle, setPanelTitle] = useState('');
    const [document, setDocument] = useState({});
    const [prevHide, setPrevHide] = useState(true);
    const [prevEnable, setPrevEnable] = useState(false);
    const [nextHide, setNextHide] = useState(false);
    const [nextEnable, setNextEnable] = useState(true);
    const [okEnable, setOkEnable] = useState(false);
    const [generalValid, setGeneralValid] = useState(false);
    const [schemaValid, setSchemaValid] = useState(false);
    const [errorEnable, setErrorEnable] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const general = useSelector((state) => state.documentConfig.general);
    const schema = useSelector((state) => state.documentConfig.schema);
    const dispatch = useDispatch();

    useEffect(() => {
        if (open) {
            const doc = {};
            setDocument(doc);
            setGeneralValid(false);
            setSchemaValid(false);
            setOkEnable(false);
            dispatch(setConfigGeneral({}));
            dispatch(setConfigSchema({}));
            dispatch(setConfigEffectivity([]));
            dispatch(setConfigOutput([]));
            setPanelIndex(0);
            setPanelId('GEN');
            loadPanelTitle('GEN');
            setPrevHide(true);
            setPrevEnable(false);
            setNextHide(false);
            setNextEnable(false);
            setErrorMessage('Please set required fields.');
            setErrorEnable(true);
            changePanel(0, doc);
            // setPanel(<CreateDocumentGeneralPanel onChange={onGeneralChange} documentList={documentList} />);
        } else {
            setDocument({});
            setGeneralValid(false);
            setSchemaValid(false);
            setOkEnable(false);
            dispatch(setConfigGeneral({}));
            dispatch(setConfigSchema({}));
            dispatch(setConfigEffectivity([]));
            dispatch(setConfigOutput([]));
        }

    }, [open]);

    useEffect(() => {
        loadPanelTitle(panelId);
    }, [title]);

    const loadPanelTitle = (pid) => {
        if (title) {
            switch (pid) {
                case 'GEN':
                    setPanelTitle(`${title}—General Information`);
                    break;
                case 'SCH':
                    setPanelTitle(`${title}—Schema`);
                    break;
                case 'EFF':
                    setPanelTitle(`${title}—Effectivity`);
                    break;
                case 'OUT':
                    setPanelTitle(`${title}—Processing Outputs`);
                    break;
            }
        } else {
            switch (pid) {
                case 'GEN':
                    setPanelTitle('General Information');
                    break;
                case 'SCH':
                    setPanelTitle('Schema');
                    break;
                case 'EFF':
                    setPanelTitle('Effectivity');
                    break;
                case 'OUT':
                    setPanelTitle('Processing Outputs');
                    break;
            }
        }
    };

    const onCancelClick = () => {
        if (typeof onCancel === 'function') {
            onCancel();
        }
    }

    const onNext = () => {
        const index = panelIndex + 1;
        if (index < CREATE_PANELS.length) {
            changePanel(index);
        }
    };

    const changePanel = (index, doc = document) => {
        setPanelIndex(index);
        setPanelId(CREATE_PANELS[index]);
        if (index >= CREATE_PANELS.length - 1) {
            setNextHide(true);
            setNextEnable(false);
        } else {
            setNextHide(false);
            setNextEnable(false);
        }
        if (index <= 0) {
            setPrevEnable(false);
            setPrevHide(true);
        } else {
            setPrevEnable(true);
            setPrevHide(false);
        }
        setErrorEnable(false);
        setErrorMessage('');

        // const pdoc = {...doc};


        //console.log('Panel DOC=' + JSON.stringify(pdoc));

        const gen = doc.general ? { ...doc.general } : {};
        dispatch(setConfigGeneral(gen));
        const sch = doc.schema ? { ...doc.schema } : {};
        dispatch(setConfigSchema(sch));
        const outs = doc.output ? [...doc.output] : [];
        dispatch(setConfigOutput(outs));
        const effs = doc.effectivity ? [...doc.effectivity] : [];
        dispatch(setConfigEffectivity(effs));

        loadPanelTitle(CREATE_PANELS[index]);
        switch (CREATE_PANELS[index]) {
            case 'GEN':
                setPanel(<CreateDocumentGeneralPanel onChange={onGeneralChange} documentList={documentList} />);
                setNextEnable(generalValid);
                if (!generalValid) {
                    setErrorMessage('Please set required fields');
                    setErrorEnable(true);
                }
                break;
            case 'SCH':
                setPanel(<CreateDocumentSchemaPanel onChange={onSchemaChange} />);
                setNextEnable(schemaValid);
                if (!schemaValid) {
                    setErrorMessage('Please set required fields');
                    setErrorEnable(true);
                }
                break;
            case 'EFF':
                setPanel(<CreateDocumentEffectivityPanel onChange={onEffectivityChange} />);
                setNextEnable(true);
                break;
            case 'OUT':
                setPanel(<CreateProcessingConfigurationPanel onChange={onOutputChange} />);
                //setNextEnable(false);
                //setNextHide(true);
                break;
        }
    };

    const onPrevious = () => {
        const index = panelIndex > 0 ? panelIndex - 1 : 0;
        changePanel(index);

    };

    const computeOkEnable = (doc) => {

    }

    const onGeneralChange = (data) => {
        // console.log('General changed: ' + JSON.stringify(data));

        const doc = { ...document };
        const status = { valid: false, message: data?.message };
        if (typeof doc?.status?.valid === 'boolean') {
            status.valid = doc.status.valid;
        }

        if (typeof data?.status?.valid === 'boolean') {
            status.valid = status.valid && data.status.valid;
            setNextEnable(data.status.valid);
            setGeneralValid(data.status.valid);
            setOkEnable(data.status.valid && schemaValid);
            if (!data.status.valid && data.status.message) {
                setErrorMessage(data.status.message);
                setErrorEnable(true);
            } else {
                setErrorMessage('');
                setErrorEnable(false);
            }
        } else {
            setNextEnable(false);
            setGeneralValid(false);
            setOkEnable(false);
        }
        doc.general = {
            id: data.id,
            name: data.name,
            description: data.description,
            shortName: data.shortName,
            type: data.type,
        };
        doc.status = status;
        setDocument(doc);

        // dispatch(setConfigDocument(doc));
    };

    const onSchemaChange = (data) => {
        // console.log('Schema changed: ' + JSON.stringify(data));
        const doc = { ...document };
        doc.schema = {
            schemaName: data.schemaName,
            schemaLabel: data.schemaLabel,
            styleName: data.styleName,
            schemaInfo: data.schemaInfo ? { ...data.schemaInfo } : null,
            styleInfo: data.styleInfo ? { ...data.styleInfo } : null,
        };
        const status = { schemaValid: false, message: data?.message };
        if (typeof data?.status?.schemaValid === 'boolean') {
            status.valid = status.valid && data.status.schemaValid;
            setNextEnable(data.status.schemaValid);
            setSchemaValid(data.status.schemaValid);
            setOkEnable(data.status.schemaValid && generalValid);
            if (!data.status.schemaValid && data.status.message) {
                setErrorMessage(data.status.message);
                setErrorEnable(true);
            } else {
                setErrorMessage('');
                setErrorEnable(false);
            }
        } else {
            setNextEnable(false);
            setSchemaValid(false);
            setOkEnable(false);
        }
        doc.status = status;
        setDocument(doc);
        // dispatch(setConfigDocument(doc));
    };

    const onEffectivityChange = (data) => {
        // console.log('Effectivity changed: ' + JSON.stringify(data));
        const doc = { ...document };
        doc.effectivity = data;
        setDocument(doc);
    };

    const onOutputChange = (data) => {
        // console.log('Outputs changed: ' + JSON.stringify(data));
        const outs = [...data];
        const doc = { ...document };
        doc.output = outs;
        setDocument(doc);
    };

    const onCommit = () => {
        setConfirmDialogOpen(true);
    };

    const onConfirm = () => {
        setConfirmDialogOpen(false);
        // ok, finally create the document
        const info = {
            id: document.general.id,
            shortName: document.general.shortName,
            title: document.general.name,
            categories: 'CLOUD',
            schema: {
                id: document.schema.schemaName,
            },
            pageMaster: {
                name: document.schema.styleName,
            }
        };
        netPost('/api/doc/create', info)
            .then(resp => {
                if (!resp.ok) {
                    console.log('Could not create document: status = ' + resp.status);

                } else {
                    const dlentry = {
                        name: document.general.id,
                        label: document.general.name,
                        description: document.general.description,
                        category: 'DOC',
                        properties: {
                            general: {
                                shortName: document.general.shortName,
                                model: document.general.type,
                                otherModel: '',
                                otherShortName: '',
                                description: document.general.description,
                            },
                            schema: document.schema,
                            eff: {
                                source: document.effectivity,
                                target: document.output,
                            },
                        },
                    };
                    netPost('/api/dlib/config/set', dlentry)
                        .then(resp => resp.json())
                        .then(config => {
                            console.log('New DL config entry: ' + JSON.stringify(config));
                        }).catch(error => {
                            const msg = 'Error storing DL config for new document: ' + error;
                            console.log(msg);
                            /*
                            setStatusMessage(msg);
                            setStatusSeverity('error');
                            setStatusOpen(true);
                            */
                        });
                    if (typeof onSave === 'function') {
                        onSave(document);
                    }
                }
            }).catch(error => console.log('Error creating document: ' + error));
    };

    return (
        <React.Fragment>
            <WizardDialog open={open} title={panelTitle} onCancel={onCancelClick} panel={panel}
                previousHide={prevHide} previousEnabled={prevEnable}
                nextHide={nextHide} nextEnable={nextEnable}
                onNext={onNext} onPrevious={onPrevious}
                okEnabled={okEnable} onSave={onCommit}
                errorEnable={errorEnable}
                errorMessage={errorMessage}
            />
            <ConfirmCreateDocument open={confirmDialogOpen} document={document} onCancel={() => setConfirmDialogOpen(false)} onSave={onConfirm} />
        </React.Fragment>
    );
};

function ConfirmCreateDocument(props) {
    const {
        title = 'Confirm Document Settings',
        document,
        open,
        onCancel,
        onSave,
        ...other
    } = props;

    useEffect(() => {
        if (open && document) {
            console.log('Outputs: ' + JSON.stringify(document?.output))
        }

    }, [open, document]);

    const onOKClick = () => {
        if (typeof onSave === 'function') {
            onSave(document);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const getFormat = (item) => {
        let format = '';
        if (item?.data?.ename) {
            format = item.data.ename;
        }
        if (item?.data?.format) {
            format += ' ' + item.data.format;
        } else {
            format += ' PDF';
        }
        return format;
    }

    return (
        <Dialog
            maxWidth={'1000px'}
            open={open}
            disableRestoreFocus
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 600,
                        maxHeight: 700
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent>

                <Box sx={{ paddingTop: '2ex', display: 'flex' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '7em' }}>Name:</Typography>
                    <Typography>{document.general?.name}</Typography>
                </Box>
                <Box sx={{ paddingTop: '2ex', display: 'flex' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '7em' }}>Identifier:</Typography>
                    <Typography>{document.general?.id}</Typography>
                </Box>
                <Box sx={{ paddingTop: '2ex', display: 'flex' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '7em' }}>Schema:</Typography>
                    <Typography>{document.schema?.schemaLabel}</Typography>
                </Box>
                <Box sx={{ paddingTop: '2ex', display: 'flex' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '7em' }}>Style:</Typography>
                    <Typography>{document.schema?.styleName}</Typography>
                </Box>

                <Box sx={{ paddingTop: '2ex' }}>
                    <Typography sx={{ fontWeight: 'bold' }}>Effectivity:</Typography>
                    {Array.isArray(document.effectivity) && document.effectivity.length > 0 ?
                        <List sx={{ mt: 0, pt: 0, pb: 0 }}>
                            {document.effectivity.map((item, index) =>
                                <ListItem key={`eff001-${index}`} sx={{ pt: 0, pb: 0 }}>
                                    <ListItemText primary={item.data?.ename} />
                                </ListItem>
                            )}
                        </List>
                        :
                        <Typography>None</Typography>
                    }
                </Box>

                <Box sx={{ paddingTop: 1 }}>
                    <Typography sx={{ fontWeight: 'bold' }}>Processing Outputs:</Typography>
                    {Array.isArray(document.output) && document.output.length > 0 ?
                        <List sx={{ mt: 0, pt: 0 }}>
                            {document.output.map((item, index) =>
                                <ListItem key={`out001-${index}`} sx={{ pt: 0, pb: 0 }}>
                                    <ListItemText primary={getFormat(item)} />
                                </ListItem>
                            )}
                        </List>
                        :
                        <Typography>ALL PDF</Typography>
                    }
                </Box>

                <Box sx={{ paddingTop: '5ex' }}>
                    <Typography sx={{ display: 'inline', fontWeight: 'bold' }}>Create document?</Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ padding: 3 }}>
                <Button variant="outlined" onClick={onOKClick} sx={{ minWidth: '7em' }} color="error" autoFocus >Create</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em' }}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}

function DocumentConfiguration(props) {

    const [documentList, setDocumentList] = React.useState([]);
    const [selectedIndex, setSelectedIndex] = React.useState(-1);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [saveDocumentEnabled, setSaveDocumentEnabled] = React.useState(false);
    const [checkoutEnabled, setCheckoutEnabled] = React.useState(false);
    const [checkinEnabled, setCheckinEnabled] = React.useState(false);
    const [modified, setModified] = React.useState([]);
    const [rulesMap, setRulesMap] = React.useState({});
    const [profilesMap, setProfilesMap] = React.useState({});
    const [revrecMap, setRevrecMap] = React.useState({});
    const [generalMap, setGeneralMap] = useState({});
    const [schemaMap, setSchemaMap] = useState({});
    const [effectivityMap, setEffectivityMap] = useState({});
    const [outputMap, setOutputMap] = useState({});
    const [contextMenu, setContextMenu] = React.useState(null);
    const [openCreateDialog, setOpenCreateDialog] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [updateDocs, setUpdateDocs] = useState(0);
    // temporary notice/alert popup
    const [statusMessage, setStatusMessage] = useState('');
    const [statusSeverity, setStatusSeverity] = useState('');
    const [statusOpen, setStatusOpen] = useState(false);

    const dispatch = useDispatch();
    const theme = useTheme();

    React.useEffect(() => {
        loadDocs();
    }, [updateDocs]);

    const loadDocs = (did, lock = false) => {
        netGet('/api/doc/roots')
            .then(response => response.json())
            .then(docs => {
                if (Array.isArray(docs)) {
                    // console.log('Got ' + docs.length + ' documents.\n' + JSON.stringify(docs));

                    if (did) {
                        const di = docs.findIndex(d => d.id === did);
                        if (di >= 0) {
                            setSelectedIndex(di);
                        }
                        if (lock) {
                            docs[di].configLock = UserInfo.info.name;
                        }
                    }
                    setDocumentList(docs);
                    // get also the "create document" workflows in progress
                    /* DISABLE workflows
                    netGet('/api/workflow/inst/find/bystate/MGT_DOC')
                        .then(resp => resp.json())
                        .then(insts => {
                            // console.log('Got create workflow documents: ' + JSON.stringify(insts));
                            if ( Array.isArray(insts) ) {
                                const einsts = [];
                                insts.forEach( wi => {
                                    const di = docs.find( d => d.id === wi.properties?.document );
                                    if ( di ) {
                                        // mark it as MGT as it has dlib config and associated workflow
                                        di['docType'] = 'MGT_DOC';
                                        di['workflowInstance'] = wi;
                                    } else {
                                        einsts.push(wi);
                                    }
                                });

                                const dinsts = einsts.map( wi => {
                                    return {
                                        id: wi.properties?.document,
                                        document: wi.properties?.document,
                                        title: wi.properties?.instanceName,
                                        workflowInstance: wi,
                                        docType: 'MGT_DOC', // as oppose to DDIS

                                    };
                                });
                                const dss = [ ...docs, ...dinsts];
                                dss.sort( (a,b) => a.title.localeCompare(b.title));
                                setDocumentList(dss);
                                if ( nextDocumentSelectedId && typeof nextDocumentSelectedId === 'string' && nextDocumentSelectedId.trim() !== '' ) {
                                    const j = dss.findIndex( d => d.id === nextDocumentSelectedId);
                                    if ( j >= 0 ) {
                                        setSelectedIndex(j);
                                        nextDocumentSelectedId = null;
                                    }
                                }
                            }
                        }).catch ( err => {
                            console.log('Error fetching management create document workflows: ' + err);
                        });
                    */
                }
            }).catch(error => {
                console.log('Error fetching document roots: ' + error);
            });
    };

    const lockIconLabel = (index) => {
        const doc = documentList[index];
        if (doc.configLock && doc.configLock !== '') {
            return 'Locked by ' + doc.configLock;
        }
        return '';
    };

    const lockIconColor = (index) => {
        const doc = documentList[index];
        // console.log('index: ' + index + ', user=' + def.user);
        if (doc.configLock && doc.configLock !== '') {
            if (doc.configLock === UserInfo.info.name) {
                return 'green';
            } else {
                return '#cc0000';
            }
        }
        return 'transparent';
    };

    const modifiedColor = (index) => {
        return saveRequired(index) ? 'black' : 'transparent';
    };

    const modifiedLabel = (index) => {
        return saveRequired(index) ? 'Modified' : null;
    };

    const isLockedByMe = (index) => {
        let doc = documentList[index];
        return typeof doc.configLock === 'string' && doc.configLock.length > 0 && doc.configLock === UserInfo.info.name;
    };

    const isLocked = (index) => {
        let doc = documentList[index];
        return typeof doc.configLock === 'string' && doc.configLock.length > 0;
    };

    const saveRequired = (index) => {
        return modified.includes(index);
    };

    const markModified = () => {
        const m = [...modified];
        if (!m.includes(selectedIndex)) {
            m.push(selectedIndex);
        }
        setModified(m);

        setSaveDocumentEnabled(true);
        // setUndoSaveEnabled(true);
        // modified inhibites checkin
        setCheckinEnabled(false);
    };

    const unmarkModified = () => {
        const m = modified.filter(item => item !== selectedIndex);
        setModified(m);
        setCheckinEnabled(isLockedByMe(selectedIndex));
        setSaveDocumentEnabled(false);
        // setUndoSaveEnabled(false);
    };

    const doUnmarkModified = (index) => {
        const m = modified.filter(item => item !== index);
        setModified(m);
        // setCheckinEnabled(isLockedByMe(index));
    };


    const handleItemClick = (index) => {
        setSelectedIndex(index);
        if (Array.isArray(documentList)) {
            const doc = documentList[index];
            if (doc) {
                setSelectedDocument(doc);
            } else {
                setSelectedDocument(null);
            }
        } else {
            setSelectedDocument(null);
        }
        if (isLocked(index)) {
            setCheckoutEnabled(false);
            setCheckinEnabled(isLockedByMe(index));
        } else {
            setCheckoutEnabled(true);
            setCheckinEnabled(false);
        }
    };

    const documentChangeHandler = (rules, doc, docIndex, otherConfig) => {
        if (rules) {
            const rm = { ...rulesMap };
            rm[doc.id] = rules;
            setRulesMap(rm);
        }
        if (otherConfig?.profiles) {
            const pf = otherConfig.profiles;
            const pm = { ...profilesMap };
            pm[doc.id] = pf;
            setProfilesMap(pm);
        }
        if (otherConfig?.revrec) {
            const rr = { ...revrecMap };
            rr[doc.id] = otherConfig.revrec;
            setRevrecMap(rr);
        }
        if (otherConfig?.general) {
            const gen = { ...generalMap };
            gen[doc.id] = otherConfig.general;
            setGeneralMap(gen);
        }
        if (otherConfig?.schema) {
            const sch = { ...schemaMap };
            sch[doc.id] = otherConfig.schema;
            setSchemaMap(sch);
        }
        if (otherConfig?.effectivity) {
            const eff = { ...effectivityMap };
            eff[doc.id] = otherConfig.effectivity;
            setEffectivityMap(eff);
        }
        if (otherConfig?.output) {
            const out = { ...outputMap };
            out[doc.id] = otherConfig.output;
            setOutputMap(out);
        }
        markModified();
    };

    const handleCheckoutAction = () => {
        const doc = documentList[selectedIndex];
        doc.configLock = UserInfo.info.name;
        const dlist = [...documentList];
        setDocumentList(dlist);
        handleItemClick(selectedIndex);
        handleContextMenuClose();
    };

    const handleCheckinAction = () => {
        const doc = documentList[selectedIndex];
        doc.configLock = '';
        const dlist = [...documentList];
        setDocumentList(dlist);
        handleItemClick(selectedIndex);
        handleContextMenuClose();
    };

    const handleRevokeCheckoutAction = () => {
        const doc = documentList[selectedIndex];
        doc.configLock = '';
        const dlist = [...documentList];
        setDocumentList(dlist);
        handleItemClick(selectedIndex);
        handleContextMenuClose();
    };

    const handleSaveDocumentAction = () => {
        unmarkModified();
        handleItemClick(selectedIndex);
        const doc = documentList[selectedIndex];
        if (rulesMap && rulesMap[doc.id]) {
            // console.log('rules[' + doc.id + ']=' + JSON.stringify(rulesMap[doc.id]));
            const key = `${doc['configBaseKey']}.workflow.keeps.word.rules`;
            netPost(`/api/config/set?key=${key}`, rulesMap[doc.id])
                .then(resp => {
                    if (!resp.ok) {
                        console.log('Could not save rules: status = ' + resp.status);

                    } else {
                        // delete def.saveSteps;
                        setSaveDocumentEnabled(false);
                        handleItemClick(selectedIndex);
                        rulesMap[doc.id] = undefined;
                        unmarkModified();
                    }
                });
        }
        if (profilesMap && profilesMap[doc.id]) {
            // console.log('down profiles[' + doc.id + ']=' + JSON.stringify(profilesMap[doc.id]));
            const key = `${doc['configBaseKey']}.download.profiles`;
            netPost(`/api/config/set?key=${key}`, profilesMap[doc.id])
                .then(resp => {
                    if (!resp.ok) {
                        console.log('Could not save rules: status = ' + resp.status);
                    } else {
                        // delete def.saveSteps;
                        setSaveDocumentEnabled(false);
                        handleItemClick(selectedIndex);
                        profilesMap[doc.id] = undefined;
                        unmarkModified();
                    }
                });
        }
        if ( (generalMap && generalMap[doc.id]) || 
             (schemaMap && schemaMap[doc.id]) || 
             (effectivityMap && effectivityMap[doc.id]) || 
             (outputMap && outputMap[doc.id]) ) {
            const gen = generalMap[doc.id];
            const schema = schemaMap[doc.id];
            const eff = effectivityMap[doc.id];
            const out = outputMap[doc.id];
            netGet('/api/dlib/config/get/byname/' + encodeURIComponent(doc.id) + '?categ=DOC')
                .then(resp => resp.json())
                .then(config => {
                    if (config) {
                        // setConfig(config);
                        // console.log('CONFIG: ' + JSON.stringify(config));
                        // console.log('DESC: ' + JSON.stringify(gen));
                        if (typeof gen?.description === 'string') {
                            config.description = gen.description;
                            
                            if (config.properties?.general) {
                                config.properties.general.description = gen.description;
                            }
                            
                        }
                        if ( schema && config.properties ) {
                            config.properties.schema = schema;
                        }
                        if ( eff && config.properties?.eff) {
                            config.properties.eff.source = eff;
                            // console.log('EFF: ' + JSON.stringify(eff));
                        }
                        if ( out && config.properties?.eff ) {
                            config.properties.eff.target = out;
                        }
                        netPost('/api/dlib/config/set?mod=1', config)
                            .then(resp => resp.json())
                            .then(config => {
                                // console.log('New DL config entry: ' + JSON.stringify(config));
                            }).catch(error => {
                                const msg = 'Error storing DL config for new document: ' + error;
                                console.log(msg);
                                /*
                                setStatusMessage(msg);
                                setStatusSeverity('error');
                                setStatusOpen(true);
                                */
                                // generalMap[doc.id] = undefined;
                                if ( eff ) {
                                    effectivityMap[doc.id] = undefined;
                                    setSaveDocumentEnabled(false);
                                    unmarkModified();
                                }
                                if ( out ) {
                                    outputMap[doc.id] = undefined;
                                    setSaveDocumentEnabled(false);
                                    unmarkModified();
                                }
                            });
                        /*
                        const m = config.properties?.general?.model ? config.properties.general.model : '';
                        setTypeValue(m);
                        const om = config.properties?.general?.otherModel ? config.properties.general.otherModel : '';
                        setOtherValue(om);
                        const s = config.properties?.general?.shortName ? config.properties.general.shortName : '';
                        setShortNameValue(s);
                        const os = config.properties?.general?.otherShortName ? config.properties.general.otherShortName : '';
                        setOtherShortValue(os);
                        if (config.description) {
                            setDescriptionValue(config.description);
                        } else if (config.properties?.general?.description) {
                            setDescriptionValue(config.properties.general.description);
                        }
                        let n = config.properties?.general?.displayName ? config.properties?.general?.displayName : inst.properties?.instanceName;
                        if (!n) {
                            n = '';
                        }
                        computeOkEnable(inst.properties?.document, n, m, om, s, os);
                        */
                    }
                }).catch(error => {
                    console.log('Failed to retrieve DL config for document: ' + doc.id + ' : ' + error);
                });
        }
        if (generalMap && generalMap[doc.id]) {
            console.log('Saving general: ' + JSON.stringify(generalMap[doc.id]));
            const dinfo = {
                id: doc.id,
                title: generalMap[doc.id].title,
            };
            netPost('/api/doc/update', dinfo)
                .then(resp => {
                    if (!resp.ok) {
                        console.log('Could not save document title: status = ' + resp.status);
                    } else {
                        // delete def.saveSteps;
                        setSaveDocumentEnabled(false);
                        // handleItemClick(selectedIndex);
                        generalMap[doc.id] = undefined;
                        unmarkModified();
                        loadDocs(doc.id, true);
                    }
                }).catch(error => console.log('Could not save document general ' + error));
            /*
            const key = `${doc['configBaseKey']}.displayName`;
            netPost(`/api/config/set?key=${key}`, generalMap[doc.id].title)
                .then(resp => {
                    if (!resp.ok) {
                        console.log('Could not save rules: status = ' + resp.status);
                    } else {
                        // delete def.saveSteps;
                        setSaveDocumentEnabled(false);
                        handleItemClick(selectedIndex);
                        generalMap[doc.id] = undefined;
                        unmarkModified();
                    }
                });
            */
            // TODO: save it in the dlib config
        }
        if ( schemaMap && schemaMap[doc.id]) {
            console.log('Schema: ' + JSON.stringify(schemaMap[doc.id]));
            const dinfo = {
                id: doc.id,
                schema: schemaMap[doc.id].schemaInfo,
                pageMaster: schemaMap[doc.id].styleInfo,
            }
            console.log('SCHEMA: ' + JSON.stringify(dinfo));
            netPost('/api/doc/style', dinfo)
                .then(resp => {
                    if (!resp.ok) {
                        console.log('Could not save document schema/style: status = ' + resp.status);
                    } else {
                        // delete def.saveSteps;
                        setSaveDocumentEnabled(false);
                        // handleItemClick(selectedIndex);
                        schemaMap[doc.id] = undefined;
                        unmarkModified();
                        loadDocs(doc.id, true);
                    }
                }).catch(error => console.log('Could not save document general ' + error));
        };
        
        if (revrecMap && revrecMap[doc.id]) {
            if (revrecMap[doc.id].revrec) {
                netPost('/api/doc/revrec', revrecMap[doc.id].revrec)
                    .then(resp => {
                        if (!resp.ok) {
                            console.log('Could not save revision records: status = ' + resp.status);
                        } else {
                            revrecMap[doc.id].revrec = undefined;

                            // delete def.saveSteps;
                            setSaveDocumentEnabled(false);
                            handleItemClick(selectedIndex);
                            unmarkModified();
                        }
                    });
            }
            if (revrecMap[doc.id].numberOfRecords) {
                netPost(`/api/config/set?key=${revrecMap[doc.id].configKey}`, `${revrecMap[doc.id].numberOfRecords}`)
                    .then(resp => {
                        if (!resp.ok) {
                            console.log('Could not number of records: status = ' + resp.status);
                        } else {
                            revrecMap[doc.id].numberOfRecords = undefined;
                            // delete def.saveSteps;
                            setSaveDocumentEnabled(false);
                            handleItemClick(selectedIndex);
                            unmarkModified();
                        }
                    });
            }

        }
        handleContextMenuClose();
    };

    const handleContextMenu = (event, index) => {
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.clientX + 2,
                    mouseY: event.clientY - 6,
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                // Other native context menus might behave different.
                // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null,
        );

        if (index >= 0) {
            handleItemClick(index);
        }
    };

    const handleContextMenuClose = () => {
        setContextMenu(null);
    };

    const handleCreateAction = () => {
        setContextMenu(null);
        setOpenCreateDialog(true);

    };

    const createActionSave = (doc) => {
        setOpenCreateDialog(false);
        openStatusMessage('Document ' + doc?.general?.id + ' ' + doc?.general?.name + ' created successfully');
        loadDocs(doc.general?.id);
        // already created, just close
        /*
        netGet('/api/workflow/def/list?categ=DEF_MGT_DOC' )
            .then(response => response.json())
            .then(defs => {
                if ( Array.isArray(defs) ) {
                    // serverStartWorkflow(defs[0], props.name, props.description, props.name, props.id, props, action);
                    createDocInstance(defs[0], props, action);
                }
            }).catch(error => {
                console.log('Error fetching def for MGT_DOC ' + error);
            });
        */
    }

    const createDocInstance = (def, props, action) => {
        const createInfo = {
            id: props.id,
            shortName: props.shortName === 'Other' ? props.otherShortName : props.shortName,
            title: props.name,
        }
        netPost('/api/doc/create', createInfo)
            .then(resp => resp.json())
            .then(docItem => {
                serverStartWorkflow(def, props.name, props.description, props.name, props.id, props, action);
            }).catch(error => {
                const msg = 'Failed to start create document instance: ' + error;
                console.log(msg);
                setStatusMessage(msg);
                setStatusSeverity('error');
                setStatusOpen(true);
            });
    };

    const serverStartWorkflow = (def, label, description, instance, docid, props, action) => {

        let info = {
            definition: def
        };
        if (label) {
            info['label'] = label;
        }
        if (description) {
            info['description'] = description;
        }
        if (instance) {
            info['instance'] = instance;
        }
        if (docid && docid !== 'NONE' && docid !== 'None' && docid !== '') {
            info['document'] = docid;
        }

        info['properties'] = {
            runtimeState: 'MGT_DOC', // this sets it for use only of management
        };
        console.log('Creating workflow instance with params: ' + JSON.stringify(info));
        netPost('/api/workflow/inst/start', info)
            .then(resp => resp.json())
            .then(inst => {
                console.log('Created workflow instance: ' + JSON.stringify(inst));
                if (inst?.id) {
                    netGet('/api/workflow/step/claim/' + inst.id)
                        .then(resp => {
                            if (!resp.ok) {
                                console.log('Could not claim create workflow: status = ' + resp.status);
                            } else {
                                if (inst?.properties?.document) {
                                    nextDocumentSelectedId = inst.properties.document;
                                } else {
                                    nextDocumentSelectedId = '';
                                }
                                // always go to next
                                // if ( action === 'NEXT' ) {
                                netGet('/api/workflow/step/complete/' + inst.id)
                                    .then(response => {
                                        if (!response.ok) {
                                            console.log('Could not complete step: error = ' + response.status);
                                        } else {
                                            // and claim it
                                            netGet('/api/workflow/step/claim/' + inst.id)
                                                .then(resp => {
                                                    if (!resp.ok) {
                                                        console.log('Could not claim create workflow: status = ' + resp.status);
                                                    } else {
                                                        // don't open next step's dialog automatically but advance there anyway
                                                        // dispatch(setOpenNextStep({ openNextStep: true, openStepAction: 'GEN', openWorkflowId: inst.id }));
                                                        // and trigger the update after coming to next step
                                                        // not necessary as the modified notification from server will trigger it
                                                        setUpdateDocs(updateDocs => updateDocs + 1);

                                                        setStatusMessage('Document configuration created successfully.');
                                                        setStatusSeverity('success');
                                                        setStatusOpen(true);
                                                    }
                                                }).catch(error => {
                                                    const msg = 'Could not claim creation workflow: ' + error;
                                                    console.log(msg);
                                                    setStatusMessage(msg);
                                                    setStatusSeverity('error');
                                                    setStatusOpen(true);

                                                });
                                        }
                                    });
                                /*
                                } else {
                                    // only update
                                    setUpdateDocs( updateDocs => updateDocs + 1);
                                }
                                */
                            }
                        }).catch(error => {
                            const msg = 'Could not claim creation workflow: ' + error;
                            console.log(msg);
                            setStatusMessage(msg);
                            setStatusSeverity('error');
                            setStatusOpen(true);
                        });
                    const dlentry = {
                        name: docid,
                        label: label,
                        description: description,
                        category: 'DOC',
                        properties: {
                            general: {
                                shortName: props.shortName,
                                model: props.type,
                                otherModel: props.other,
                                otherShortName: props.otherShortName,
                            }
                        },
                    };
                    netPost('/api/dlib/config/set', dlentry)
                        .then(resp => resp.json())
                        .then(config => {
                            console.log('New DL config entry: ' + JSON.stringify(config));
                        }).catch(error => {
                            const msg = 'Error storing DL config for new document: ' + error;
                            console.log(msg);
                            setStatusMessage(msg);
                            setStatusSeverity('error');
                            setStatusOpen(true);
                        });
                }
            }).catch(error => {
                const msg = 'Failed to start create document workflow: ' + error;
                console.log(msg);
                setStatusMessage(msg);
                setStatusSeverity('error');
                setStatusOpen(true);
            });
    };

    const workflowInfo = (message) => {
        let wevent = message.data;
        console.log('MGT DOC Received workflow message: ' + wevent.action + ' : ' + wevent.type + ' : ' + wevent.id);
        if (wevent.type === 'WorkflowInstance') {
            // console.log('CURRENT MENU = ' + lastCurrentMenu );
            if (wevent.action === 'MODIFIED') {
                const doc = documentList.find(d => d.docType === 'MGT_DOC' && d.workflowInstance?.id === wevent.id);
                if (doc) {
                    setUpdateDocs(updateDocs => updateDocs + 1);
                }
            } else if (wevent.action === 'DELETE') {
                const doc = documentList.find(d => d.docType === 'MGT_DOC' && d.workflowInstance?.id === wevent.id);
                // console.log('MSG active doc = ' + JSON.stringify(doc));
                if (doc?.id === selectedDocument?.id) {
                    setSelectedIndex(-1);
                    setSelectedDocument(null);
                    setCheckinEnabled(false);
                    setCheckoutEnabled(false);
                }
                setUpdateDocs(updateDocs => updateDocs + 1);
            }
        }
    };

    const openStatusMessage = (msg, severity = 'success') => {
        console.log(msg);
        setStatusMessage(msg);
        setStatusSeverity(severity);
        setStatusOpen(true);
    };

    const handleDeleteAction = () => {
        setOpenDeleteDialog(true);
    };

    const deleteActionSave = (doc) => {
        setOpenDeleteDialog(false);
        serverDelete(doc);
    };

    const serverDelete0 = (doc) => {
        if (doc?.workflowInstance?.id) {
            netFetch('/api/workflow/inst/' + doc.workflowInstance.id, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + keycloak.token
                }
            })
                .then(resp => {
                    if (!resp.ok) {
                        console.log('Could not delete workflow instance: status = ' + resp.status);
                    } else {
                        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(doc?.id) + '?categ=DOC')
                            .then(resp => resp.json())
                            .then(config => {
                                if (config) {
                                    netFetch('/api/dlib/config/' + config.id, {
                                        method: 'DELETE',
                                        headers: {
                                            'Authorization': 'Bearer ' + keycloak.token
                                        }
                                    }).then(resp => {
                                        if (!resp.ok) {
                                            openStatusMessage('Could not delete DL config: status = ' + resp.status, 'error');
                                        } else {
                                            netFetch('/api/doc/delete/' + encodeURIComponent(doc?.id), {
                                                method: 'DELETE',
                                                headers: {
                                                    'Authorization': 'Bearer ' + keycloak.token
                                                }
                                            }).then(resp => {
                                                if (!resp.ok) {
                                                    openStatusMessage('Could not delete document instance: status = ' + resp.status, 'error');
                                                } else {
                                                    openStatusMessage('Document ' + doc?.id + ' deleted successfully');
                                                }
                                            });
                                        }
                                    }).catch(err => {
                                        openStatusMessage('Could not delete DL config: status = ' + err, 'error');

                                    });
                                }
                            }).catch(error => {
                                openStatusMessage('Failed to retrieve DL config for document: ' + doc.id, 'error');
                            });
                    }
                });
        }
    };

    const serverDelete = (doc) => {

        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(doc?.id) + '?categ=DOC')
            .then(resp => resp.json())
            .then(config => {
                if (config) {
                    netFetch('/api/dlib/config/' + config.id, {
                        method: 'DELETE',
                        headers: {
                            'Authorization': 'Bearer ' + keycloak.token
                        }
                    }).then(resp => {
                        if (!resp.ok) {
                            // openStatusMessage('Could not delete DL config: status = ' + resp.status, 'error');
                            console.log('Could not delete DL config: status = ' + resp.status);
                        } else {
                            /*
                            netFetch('/api/doc/delete/' + encodeURIComponent(doc?.id), {
                                method: 'DELETE',
                                headers: {
                                    'Authorization': 'Bearer ' + keycloak.token
                                }
                            }).then(resp => {
                                if (!resp.ok) {
                                    openStatusMessage('Could not delete document instance: status = ' + resp.status, 'error');
                                } else {
                                    openStatusMessage('Document ' + doc?.id + ' deleted successfully');
                                    loadDocs();
                                }
                            });
                            */
                        }
                    }).catch(err => {
                        // openStatusMessage('Could not delete DL config: status = ' + err, 'error');
                        console.log('Could not delete DL config: status = ' + err);
                    });
                }
            }).catch(error => {
                // openStatusMessage('Failed to retrieve DL config for document: ' + doc.id, 'error');
                console.log('Failed to retrieve DL config for document: ' + doc.id);
            });
        if (doc?.id) {
            netFetch('/api/doc/delete/' + encodeURIComponent(doc?.id), {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + keycloak.token
                }
            }).then(resp => {
                if (!resp.ok) {
                    openStatusMessage('Could not delete document instance: status = ' + resp.status, 'error');
                } else {
                    openStatusMessage('Document ' + doc?.id + ' deleted successfully');
                    loadDocs();
                    setSelectedIndex(-1);
                }
            });
        }

    };

    const handleStatusClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setStatusOpen(false);
        // setStatusMessage('');
        // setStatusSeverity('success');
    };



    MessageHooks["workflow"]["ManagementDocConfig"] = workflowInfo;

    return (
        <Box sx={{ height: '100%', width: '100%', display: 'grid', gridTemplateColumns: '30% 3px 1fr', gridTemplateRows: '100%' }}>
            <Box sx={{ position: 'relative', width: '100%', height: '100%', padding: '1ex', paddingTop: '2ex', display: 'grid', gridTemplateRows: 'min-content min-content minmax(10px,1fr) min-content' }}>
                <Typography align="center" sx={{ paddingTop: '8px', paddingBottom: '2ex', fontSize: '18px', fontWeight: theme.typography.fontWeightBold }}>Documents</Typography>
                <TextField
                    id="mwa-search"
                    type="search"
                    size="small"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
                <Box
                    sx={{ position: 'relative', minHeight: '2em', overflowY: 'auto' }}
                    onContextMenu={(event) => handleContextMenu(event, -1)}
                >

                    <List sx={{ minHeight: '2em' }}>
                        {
                            documentList.map((doc, index) => (
                                <ListItem
                                    key={'mwdc-' + index}
                                    sx={{ padding: 0, paddingTop: 0, paddingBottom: 0, alignItems: 'baseline' }}
                                    onContextMenu={(event) => handleContextMenu(event, index)}
                                >
                                    <Box sx={{ alignItems: 'baseline', float: 'left', color: lockIconColor(index), fontSize: '12px' }}>
                                        <Tooltip title={lockIconLabel(index)}>
                                            <span>
                                                <LockIcon fontSize="inherit" />
                                            </span>
                                        </Tooltip>
                                    </Box>
                                    <Box sx={{ alignItems: 'baseline', float: 'left', color: modifiedColor(index), fontSize: '12px', paddingTop: '0.5ex' }}>
                                        <span>
                                            <Tooltip title={modifiedLabel(index)}>
                                                <Typography sx={{ paddingLeft: '4px' }}>*</Typography>
                                            </Tooltip>
                                        </span>
                                    </Box>
                                    <ListItemButton onClick={(event) => handleItemClick(index)} sx={{ paddingLeft: '4px' }} selected={selectedIndex === index}>
                                        <ListItemText>{doc.title}</ListItemText>
                                    </ListItemButton>
                                </ListItem>
                            )
                            )
                        }
                    </List>
                </Box>
                <Box sx={{ padding: '1ex', whiteSpace: 'nowrap', overflowX: 'hidden' }} color={theme.palette.primary.main}>
                    <Tooltip title="Checkout Document">
                        <span>
                            <IconButton color="inherit" disabled={!checkoutEnabled} onClick={handleCheckoutAction} sx={{ paddingLeft: '2px', paddingRight: '6px' }}>
                                <OutputIcon color="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Revoke Checkout Document">
                        <span>
                            <IconButton color="inherit" disabled={true} onClick={handleRevokeCheckoutAction} sx={{ paddingLeft: '6px', paddingRight: '6px' }}>
                                <ReplayIcon color="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Save Document Configuration">
                        <span>
                            <IconButton color="inherit" disabled={!saveDocumentEnabled} sx={{ paddingLeft: '6px', paddingRight: '6px' }} onClick={handleSaveDocumentAction}>
                                <SaveAltIcon color="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Checkin Document">
                        <span>
                            <IconButton color="inherit" disabled={!checkinEnabled} onClick={handleCheckinAction} sx={{ paddingLeft: '6px', paddingRight: '6px' }}>
                                <ExitToAppIcon color="inherit" sx={{ transform: 'rotate(180deg)' }} />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Create Document">
                        <span>
                            <IconButton color="inherit" onClick={handleCreateAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                                <AddIcon color="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Delete Document">
                        <span>
                            <IconButton color="inherit" disabled={!checkoutEnabled} onClick={handleDeleteAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                                <DeleteIcon color="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Box>
                <Menu
                    open={contextMenu !== null}
                    onClose={handleContextMenuClose}
                    anchorReference="anchorPosition"
                    anchorPosition={
                        contextMenu !== null
                            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                            : undefined
                    }
                >
                    <MenuItem onClick={handleCheckoutAction} disabled={!checkoutEnabled}>Checkout</MenuItem>
                    <MenuItem disabled={true}>Revoke Checkout</MenuItem>
                    <MenuItem disabled={true}>Save</MenuItem>
                    <MenuItem onClick={handleCheckinAction} disabled={!checkinEnabled} divider>Checkin</MenuItem>
                    <MenuItem onClick={handleCreateAction}>New Document</MenuItem>
                    <MenuItem onClick={handleDeleteAction}>Delete Document</MenuItem>
                </Menu>
                {/* <CreateDocumentGeneralDialog open={openCreateDialog} onSave={createActionSave} onCancel={() => setOpenCreateDialog(false)} initial={true} /> */}
                <DocumentCreateDialog open={openCreateDialog} onCancel={() => setOpenCreateDialog(false)} onSave={createActionSave} />
                <DocumentDeleteDialog open={openDeleteDialog} onSave={deleteActionSave} onCancel={() => setOpenDeleteDialog(false)} document={selectedDocument} />
            </Box>

            <Divider orientation="vertical" />

            <Box sx={{ overflowY: 'auto', position: 'relative', height: '100%' }}>

                <Box sx={{ height: '100%' }}>
                    {
                        documentList && documentList.length > 0 && selectedIndex >= 0 ?
                            (documentList[selectedIndex]?.docType === 'MGT_DOC' ?
                                <WorkflowInstance instance={documentList[selectedIndex].workflowInstance} /> :
                                <DocumentConfigEdit doc={documentList[selectedIndex]} onChange={documentChangeHandler} documentIndex={selectedIndex}
                                    saveEnabled={saveDocumentEnabled} documentList={documentList} readOnly={!checkinEnabled && !saveDocumentEnabled} />)
                            : null
                    }
                </Box>
                <Snackbar open={statusOpen} autoHideDuration={3000} onClose={handleStatusClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} >
                    <Alert
                        onClose={handleStatusClose}
                        severity={statusSeverity}

                        sx={{ width: '100%' }}
                    >
                        {statusMessage}
                    </Alert>
                </Snackbar>
            </Box>
        </Box>

    );
}

export { DocumentConfiguration, };